import React from "react";

const Contact = () => {
  return (
    <div className="mt-5">
      <h1>This is Contact</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor modi
        adipisci vel, accusamus explicabo mollitia? Excepturi aut ut accusamus
        aliquam.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe pariatur
        unde accusamus, sunt quia ratione architecto? Ipsam ut accusamus beatae,
        hic, repellendus ullam magnam deleniti amet adipisci, reprehenderit
        nemo. Voluptatum architecto quam aliquam eum culpa sit reiciendis
        voluptates consectetur labore nisi aspernatur asperiores rerum
        laboriosam voluptatibus, maiores laudantium doloremque reprehenderit?
      </p>
    </div>
  );
};

export default Contact;
